import { Clipboard } from "@angular/cdk/clipboard";
import { Directive, inject, input } from "@angular/core";
import { TranslocoService } from "@ngneat/transloco";
import { ToastService } from "@app/shared/ui";

@Directive({
  selector: "[appCopyToClipboard]",
  standalone: true,
  host: {
    "(click)": "onClick()"
  }
})
export class CopyToClipboardDirective {
  readonly value = input<string | null | undefined>("", { alias: "appCopyToClipboard" });
  readonly copyToastMessage = input<string>("");

  private readonly clipboard = inject(Clipboard);
  private readonly toast = inject(ToastService);
  private readonly transloco = inject(TranslocoService);

  onClick(): void {
    const value = this.value();
    if (!value) return;

    this.clipboard.copy(value);
    this.toast.success(
      this.copyToastMessage() || this.transloco.translate("common.messages.copiedToClipboard", { name: "" }).trim()
    );
  }
}
